import Typography, { TypographyProps } from '@mui/material/Typography';

export { Typography, TypographyProps };
